export const asArray = (value) => Array.isArray(value) ? value : [];

export const buildStaticChartConfig = (options) => ({
    ...options,
    chart: {
        ...options.chart,
        selection: {enabled: false},
        zoom: {enabled: false},
        pan: {enabled: false},
    },
});
